export default __webpack_public_path__ + "static/media/CV.51caf14b.ico";